<template>
  <div class="box">
    <div class="top">
      <div class="title"> 批量录入人员（针对2）</div>
    </div>

    <div style="display: flex;justify-content: flex-end;margin: 50px;">
      <el-button type="primary" @click="setMod()">下载导入模板</el-button>
    </div>
    <div class="innerBox">
      <div class="importBox">
        <div class="iptBox">
          <input id="excelIpt"  type="file" accept=".xlsx,.xls" @change="handleXlsx">
          <div class="fakeBox">
            {{  excelTextList.length?  excelName : 'excle表'  }}
          </div>
          <div class="clear" @click="clearData()">x</div>
        </div>

      </div>

      <div class="btn">
        <el-button type="primary" @click="submitForm()">上传数据</el-button>
      </div>

      <div v-if="errorList.length">
        导入失败名单: 
        <div v-for="(item,index) in errorList" :key="index">
          {{ item }}
        </div>
      </div>
      
    </div>

  </div>
</template>

<script>
import { submit } from '@/api/index.js'
import xlsx from 'xlsx'
export default {
  components: {},
  props: {},
  data() {
    return {
      form: {
        name: '',
        gender: '',
        id: '',
        dw: '',
        type: '',
        date: '',
      },

      excelName: '',
      excelTextList:[],
      allList: [],
      loading: null,
      errorList:[],

    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {

  },
  methods: {
    setMod() {
      import('@/utils/export2Excel').then(excel => {
        // 导出的excel表头名信息
          const tHeader = [
            '姓名',
            '性别',
            '类别',
            '编号',
            '体检单位',
            '时间',
          ]
          const filterVal = [
              'name',
              'sex',
              'category',
              'number',
              'unit',
              'dataTime',
          ]
          const list = [
            {
              name: '小红', sex: '女', category: '公共卫生', number: '1',
              unit: '体检单位111',
              dataTime: '时间2026-08-06，(这里要注意,时间前面要加上时间两个字，然后日期用-隔开)'
            },
          ]
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
              //表头
              header: tHeader,
              //数据
              data,
              //名称
              filename: '批量录入(1)excel导入模板',
              //宽度自适应
              autoWidth: true,
          })
      })
    },
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    },
    clearData() {
      this.excelTextList = []
      this.excelName =  '',
      document.getElementById('excelIpt').value = ''
    },
    handleXlsx(e) {
      const files = e.target.files
      console.log(files)
      this.excelName = files[0].name
      if (!files.length) {
        return
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert('上传格式不正确，请上传xls或者xlsx格式')
      }
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        try {
          const data = ev.target.result
          const XLSX = xlsx
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          const wsname = workbook.SheetNames[0] //取第一张表，wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) //生成json表格内容，wb.Sheets[Sheet名]获取第一个Sheet的数据
          const excellist = [] //清空接收数据
          //编辑数据
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i])
          }
          console.log('读取结果', excellist) // 此时得到的是一个内容是对象的数组需要处理
          this.excelTextList = excellist
          // this.$message({
          //   message: '数据导入成功！',
          //   type: 'success',
          // })
        } catch (e) {
          return alert('读取失败!')
        }
      }
      fileReader.readAsBinaryString(files[0])
      // var input = document.getElementById('upload_excel2')
      // input.value = ''
    },


    submitForm() {
      if (!this.excelTextList.length) {
        this.$notify({
          title: '警告',
          message: `请上传对应数据`,
          type: 'warning'
        });
        return
      }
      this.errorList = []
      this.loading = this.$loading({
        lock: true,
        text: '加载中，请勿做其他操作',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let allList = this.excelTextList
      console.log('allList',allList)

      let flag = true
      allList.forEach(item => {
        item.时间 = item.时间.replace("时间", "");
        if (!item.性别 || !item.性别 || !item.时间 || !item.编号 || !item.类别 || !item.体检单位) {
          this.$notify({
            title: '警告',
            message: `请核对${item.姓名}`,
            type: 'warning'
          });
          flag = false
        }
      })
      if (!flag) {
        this.loading.close();
        return
      }
      console.log('通过')
      this.allList = allList
      console.log('this.allList ',this.allList )
      this.putData()


    },
    async putData() {
      for (const item of this.allList) {
        let obj = JSON.stringify({
          category: item.类别,
          dataTime: item.时间,
          name: item.姓名,
          number: item.编号,
          sex: item.性别,
          unit: item.体检单位,
        })
        try {
          const res = await submit(obj);
          console.log('sub', res);
          this.$notify({
            title: '提交成功',
            message: item.姓名,
            type: 'success'
          });
          // 添加300毫秒延迟
          await new Promise(resolve => setTimeout(resolve, 500));

        } catch (error) {
          console.error('提交失败:', error);
          this.$notify({
            title: '提交失败',
            message: item.姓名,
            type: 'error'
          });
          this.errorList.push(item.姓名)
        }
      }
      this.loading.close();

    },

  }
}
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.box {
  min-height: 90vh;
  width: 98%;
  margin: 1%;
  padding: 1% 2%;
  background-color: #fff;
}
.innerBox {
  margin:  60px auto 0;
  width: 80%;
}
.importBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.iptBox {
  position: relative;
  width: 300px;
  height: 300px;
  border: #189F92 1px dashed;
  border-radius: 10px;
  // margin-left: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  input {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .clear {
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 999;
    font-size: 20px;
    color: #333;

  }
}















.el-button--primary {
    color: #FFF;
    background-color: #189F92;
    border-color: #189F92;
}
// margin-top: 100px;
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  .title {
    padding-left: 10px;
    border-left: 4px solid #189F92;
  }
  .addBtn {
    padding: 5px 20px;
    border: 1px solid #189F92;
    border-radius: 5px;
    color: #189F92;
    cursor: pointer;
  }
}
.btn {
  width: fit-content;
  margin: 50px auto;
  padding: 7px 50px;
  background-color: #189F92;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
}
.selectBox {
  width: 100%;
  padding: 20px 100px;
}
.select {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.selectText {
  display: flex;
  align-items: center;
  margin-right: 100px;
}
.img {
  width: 100px;
  height: 100px;
}
.upload {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 9;
  cursor: pointer;
}
.delete {
  color: red;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 120%;
  transform: translate(-50%,-50%);
  cursor: pointer;
}
</style>
